module.exports = __webpack_public_path__ + "static/media/searchRightImg.a35007b0.jpg";